import { render, staticRenderFns } from "./d-post-multiple-choice.vue?vue&type=template&id=77ff655c&scoped=true&"
import script from "./d-post-multiple-choice.vue?vue&type=script&lang=js&"
export * from "./d-post-multiple-choice.vue?vue&type=script&lang=js&"
import style0 from "./d-post-multiple-choice.vue?vue&type=style&index=0&id=77ff655c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff655c",
  null
  
)

export default component.exports